<h2 mat-dialog-title>{{ 'Popup.ForgotPassword.Title' | translate }}</h2>
<form [formGroup]="forgotPassForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <p>{{ 'Popup.ForgotPassword.Content' | translate }}</p>

    <fieldset>
      <!-- Email/Username -->
      <div class="form-group">
        <kj-input
          [formGroup]="forgotPassForm"
          controlName="email"
          name="email"
          iconName="email"
          placeholder="{{ 'Login.Email' | translate }}"
        ></kj-input>
      </div>

      <p [innerHTML]="'Popup.ForgotPassword.Explanation' | translate : siteConfig | safeHtml"></p>

      <p></p>
    </fieldset>
  </div>
  <div mat-dialog-actions>
    <button
      mat-dialog-close
      mat-raised-button
      role="button"
      type="submit"
      class="float-right mx-3 my-1 btn btn-secondary"
    >
      {{ 'Global.Cancel' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      role="button"
      type="submit"
      class="float-right my-1"
      [disabled]="!forgotPassForm.valid"
    >
      <!-- {{ 'Login.Button' | translate }} -->
      {{ 'Popup.ForgotPassword.Title' | translate }}
    </button>
  </div>
</form>
